import { mapStrings } from "../../lib/frTypo";

/**
 * "Les marques" reel — on-screen copy, FR only for now.
 *
 * The number and the logos come from the live snapshot (`b2c/data/brands`,
 * refreshed by `npm run sync:brands`): nothing is typed here. No reward is
 * shown, so no footnote.
 *
 * Sources:
 *   - hook, line → the team's brief (how many brands are set up on Frak;
 *                  "your recommendations can already pay there"), in the
 *                  B2C house style: tutoiement, no em dashes, no hype
 *   - end line   → landing steps.title.line2 "ton influence mérite d'être
 *                  rémunérée" (same as the Ticket reel)
 *   - end sub    → B2C cta.sub (faq.a1 free, faq.a3 no followers, /vs cash)
 */
export const BRANDS_REEL = mapStrings({
  hook: "Combien de marques sont déjà sur Frak ?",
  unit: { one: "marque", other: "marques" },
  line: "Là, tes recommandations peuvent déjà payer.",
  end: {
    line: "Ton influence mérite d'être rémunérée.",
    sub: "Gratuit. Sans abonnés. Du vrai cash.",
  },
});
